/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useParams} from 'react-router-dom'
import {useFormik} from 'formik'
import {createPass} from '../../apps/pages/users/core/_requests'
import {useNavigate} from 'react-router-dom'
import {PasswordMeterComponent} from '../../../../_metronic/assets/ts/components'
import {useAuth} from '../core/Auth'

const loginSchema = Yup.object().shape({
  senha: Yup.string()
    .min(3, 'Minimo de 3 caracteres')
    .max(50, 'Máximo de 50 caracteres')
    .required('Senha é obrigatória'),

  repeticaoSenha: Yup.string()
    .min(3, 'Minimo de 3 caracteres')
    .max(50, 'Máximo de 50 caracteres')
    .required('Usuário é obrigatório'),
})

const initialValues = {
  senha: '',
  repeticaoSenha: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function NewPassword() {
  const {id: userId} = useParams()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [errorMessage, setErrorMessage] = useState<String | undefined>(undefined)
  const {saveAuth, currentUser} = useAuth()

  useEffect(() => {
    PasswordMeterComponent.bootstrap()
  }, [])

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      setErrorMessage(undefined)
      try {
        if (values.senha !== values.repeticaoSenha) {
          formik.setFieldError('repeticaoSenha', 'As senhas não conferem')
          setSubmitting(false)
          setLoading(false)
          return
        }

        //criar validação de se a senha possui 7 caracteres no minimo, 1 letra maiusculo, 1 minusculo, 1 numero e 1 caracter especial

        if (values.senha.length < 8) {
          formik.setFieldError(
            'senha',
            'A senha deve conter no mínimo 7 caracteres no minimo, incluindo letra maiuscula, letra minuscula, numero e caracter especial'
          )
          setSubmitting(false)
          setLoading(false)
          return
        }

        setSubmitting(true)

        const {code, errors} = await createPass(userId || '', values.senha)

        console.log(code, errors)

        if (code === 500) {
          setHasErrors(true)
          setErrorMessage(errors)
          setLoading(false)
          return
        }

        navigate('/auth')
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('Os detalhes do login estão incorretos')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>Cadastre uma nova senha</h1>
      </div>
      {/* begin::Heading */}

      {/* begin::Title */}
      {hasErrors === true && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{errorMessage}</div>
        </div>
      )}

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}
      {/* begin::Input group */}
      <div className='fv-row mb-8' data-kt-password-meter='true'>
        <div className='mb-1'>
          <label className='form-label fw-bolder text-dark fs-6'>Senha</label>
          <div className='position-relative mb-3'>
            <input
              type='password'
              autoComplete='off'
              {...formik.getFieldProps('senha')}
              className={clsx(
                'form-control bg-transparent',
                {
                  'is-invalid': formik.touched.senha && formik.errors.senha,
                },
                {
                  'is-valid': formik.touched.senha && !formik.errors.senha,
                }
              )}
            />
            {formik.touched.senha && formik.errors.senha && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.senha}</span>
                </div>
              </div>
            )}
          </div>
          {/* begin::Meter */}
          <div
            className='d-flex align-items-center mb-3'
            data-kt-password-meter-control='highlight'
          >
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
          </div>
          {/* end::Meter */}
        </div>
        <div className='text-muted'>
          Use 7 caracteres ou mais com uma mistura de letras (maiusculas e minusculas), números e
          caracteres especiais.
        </div>
      </div>

      <div className='fv-row mb-8'>
        <div className='mb-1'>
          <label className='form-label fw-bolder text-dark fs-6'>Repita a Senha</label>
          <div className='position-relative mb-3'>
            <input
              type='password'
              autoComplete='off'
              {...formik.getFieldProps('repeticaoSenha')}
              className={clsx(
                'form-control bg-transparent',
                {
                  'is-invalid': formik.touched.repeticaoSenha && formik.errors.repeticaoSenha,
                },
                {
                  'is-valid': formik.touched.repeticaoSenha && !formik.errors.repeticaoSenha,
                }
              )}
            />
            {formik.touched.repeticaoSenha && formik.errors.repeticaoSenha && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.repeticaoSenha}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* begin::Action */}
      <div className='d-grid mb-10'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Continuar</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Aguarde...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}

      {/* <div className='text-gray-500 text-center fw-semibold fs-6'>
        Not a Member yet?{' '}
        <Link to='/auth/registration' className='link-primary'>
          Sign up
        </Link>
      </div>*/}
    </form>
  )
}
